/**
 * JURO pointer effects
 * ------------------------------------------------------------------
 * [data-juro-spotlight]  Publishes the pointer position as --juro-mx/--juro-my
 *                        so a halftone pool follows the cursor across a card.
 *                        After Magic UI "Magic Card".
 * [data-juro-tilt]       Tilts the card a few degrees toward the pointer.
 *                        After Aceternity UI "3D Card Effect".
 *
 * One delegated pointermove listener for the whole page, written through
 * rAF. Fine pointers only; tilt is skipped under reduced motion.
 */

(() => {
  if (window.juroPointerLoaded) return;
  window.juroPointerLoaded = true;

  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let pending = null;
  let frame = 0;

  const apply = () => {
    frame = 0;
    if (!pending) return;
    const { event } = pending;
    pending = null;

    const spot = event.target.closest?.('[data-juro-spotlight]');
    if (spot) {
      const r = spot.getBoundingClientRect();
      spot.style.setProperty('--juro-mx', `${(((event.clientX - r.left) / r.width) * 100).toFixed(1)}%`);
      spot.style.setProperty('--juro-my', `${(((event.clientY - r.top) / r.height) * 100).toFixed(1)}%`);
    }

    const tilt = event.target.closest?.('[data-juro-tilt]');
    if (tilt && !reduced.matches) {
      const r = tilt.getBoundingClientRect();
      const x = (event.clientX - r.left) / r.width - 0.5;
      const y = (event.clientY - r.top) / r.height - 0.5;
      tilt.style.setProperty('--juro-rx', `${(-y * 7).toFixed(2)}deg`);
      tilt.style.setProperty('--juro-ry', `${(x * 9).toFixed(2)}deg`);
    }
  };

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!fine.matches) return;
      pending = { event };
      if (!frame) frame = requestAnimationFrame(apply);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      const tilt = event.target.closest?.('[data-juro-tilt]');
      if (tilt && !tilt.contains(event.relatedTarget)) {
        tilt.style.removeProperty('--juro-rx');
        tilt.style.removeProperty('--juro-ry');
      }
    },
    { passive: true }
  );
})();
